var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-card col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"content-card__title"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"content-card__content"},[_vm._t("content")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057068d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/ContentCard.vue
// module id = null
// module chunks = 